const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? process.env.REACT_APP_API_URL 
  : 'http://localhost:5002';

console.log('Connected to:', process.env.NODE_ENV === 'production' ? 'Production Database' : 'Local Database');

export default API_BASE_URL;